<script lang="ts">
  import { onMount } from "svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { portalUserDtoFields } from "../../utils/TableFields/portal-user-dto.fields";
  import {
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
  } from "./user.store";

  onMount(initList);
</script>

<MainLayout>
  <Table
    loading={$loading}
    fields={portalUserDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
